import React from 'react';
import './seconday cta long.css'

const SecondaryctaLongsettings = (props) => {
    return ( 
        <button className='long-cta-bg2-setttings'>
            <nav className='yellow-cont-bg2'>
                <h2 className='cta-text-primary2'>{props.title}</h2>
            </nav>
        </button>
     );
}
 
export default SecondaryctaLongsettings;